import { ReduxState } from '../..';

export const selectPolicy = (state: ReduxState) => state.policyReducer;

export const selectIsChatPolicyAccepted = (state: ReduxState) =>
  state.policyReducer.isChatPolicyAccepted;

export const selectIsChatPolicyRejected = (state: ReduxState) =>
  state.policyReducer.isChatPolicyRejected;

export const selectChatPolicyContent = (state: ReduxState) => state.policyReducer.chatPolicyContent;

export const selectIsNewChatPolicyAvailable = (state: ReduxState) =>
  state.policyReducer.isNewChatPolicyAvailable;

export const selectNewChatPolicyTooltipShown = (state: ReduxState) =>
  state.policyReducer.newChatPolicyTooltipShown;
